import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbj63hk6dy: FaireProductEntity = {
  token: "p_cbj63hk6dy",
  type: "product",
  name: "NEW! Feline Frolic Pet Bowl",
  brandToken: "b_65zgi875pr",
  brandName: "Laurel Burch Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/09b6d292d7e2a0d195afd398eb1deaf64aec38922856907a1f1b618bded06455.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8aeacbbabb10543b483b5dd3f01de1e18562122356e87539a53db27d2dbd382.jpeg",
    "https://cdn.faire.com/fastly/d78f6eecea3b540df33b9057f76940e859867e72f1d36091141354e837a73e8d.png",
    "https://cdn.faire.com/fastly/af9a76a3d199ea9c22c81151b3b6976fb0132e59af52bbc5b0c55581479f41de.png",
  ],
  priceDollars: 10.35,
  description:
    '\n Laurel loved her animals and we think it\'s about time kitties got something bright and beautiful, too. Be the first to spoil your fur baby with this sturdy, well-crafted bowl adorned with her rainbow-hued crowd of Fantasticats. It holds one cup of food and adds paw-sonality and color to meals!\n\n\n• Removable stainless steel bowl\n• Colorful melamine base, anti-slip rubber bottom\n• Half-moon notch in base makes it easy to pick up\n• Dishwasher safe, top rack; do not microwave\n\nItem Number: PB002\nCapacity: 1 cup/8 oz. capacity \nDimensions: 4.5" bowl diam.; 5.5" base diam.; 2"H x1.25"D\nMaterial: Melamine, rubber; stainless steel\n\n',
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:40.034Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
